const data = [
    { id: 1, name: "Colaborador" },
    // { id: 2, name: "Solicitante" },
    // { id: 3, name: "Passageiro" },
    // { id: 4, name: "Motorista" },
]

export default [...data]